export default __webpack_public_path__ + "static/media/icon_info.d7956605.svg";